export default "__VITE_ASSET__C0x1ABaq__"